module.exports = __webpack_public_path__ + "static/p5.af8be35d.jpg";